import type { SelectOption } from '@repo/ui'

export function isOptionOfValue<T>(option: SelectOption<T>, value: T) {
	if (option.key) {
		return option.key(option.value) === option.key(value)
	} else {
		return JSON.stringify(option.value) === JSON.stringify(value)
	}
}

export enum SelectType {
	country = 'country',
}

export const globalLocation = 'global'
